import React, { useEffect,Suspense } from "react";
import { Outlet, useLocation } from "react-router-dom";
 
import Header from './components/common/header' 
import SideNav from './components/common/sideNav' 
import Footer from './components/common/footer' 
import UserAuth from './lib/userAuth'
import { Navigate
} from "react-router-dom";
function MainView() {
  return UserAuth() ? (
    <div className="main-container">  
      <Header />
      <SideNav />    
      <Suspense fallback={<div>Loading...</div>}>
          <Outlet />
      </Suspense>   
      <Footer />
    </div>
  ):<Navigate to="/login"  replace />;
    
}
 

export default MainView;
